import React from "react";
import AntdSpin, {SpinProps} from "antd/lib/spin";
import {withError} from '@fishx/tracker';

const setDefaultIndicator = AntdSpin.setDefaultIndicator;
interface FCProps extends React.FC<SpinProps> {
  setDefaultIndicator: typeof setDefaultIndicator;
}
export const Spin: FCProps = (props) =>{
  return <AntdSpin {...props} />;
}
Spin.setDefaultIndicator = setDefaultIndicator;
Spin.displayName = 'Spin';
export default withError(Spin);




// WEBPACK FOOTER //
// ./src/components/spin/index.tsx